/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { currencies, exchange } from '../../../../utilities/constants';
import { formatNumber } from '../../../../utilities/formatHelpers';
import { LOAN_REPAY } from '../../mutations';
import { showAlert } from '../../../../utilities/notifications';
import { WALLETS_ALL } from '../../../Accounts/queries';
import { useLedgerFilteredWallets } from '../../../../utilities/sharedHooks/ledgerWallets';
import CurrencyIcon from '../../../../components/CurrencyIcon';

const RepayLoan = ({ loanDataObj, showScreen, hideModal }) => {
  const { loanMetaData, loanData } = loanDataObj;
  const { t: translate } = useTranslation();
  const [currentWallet, setCurrentWallet] = useState();
  const [currencyBalanceLabel, setCurrencyBalanceLabel] = useState('-');

  const safeNetPrincipalAmount =
    loanData.net_principal_amount * currencies[loanMetaData.principal_currency].conversion;
  const safeCollateralAmount =
    loanData.collateral_amount * currencies[loanMetaData.collateral_currency].conversion;

  const displaySafeCollateralAmount = `${formatNumber(
    safeCollateralAmount,
    currencies[loanMetaData.collateral_currency].decimal
  )} ${loanMetaData.collateral_currency}`;

  // const safeCollateralAmountFiat = safeCollateralAmount * rate;

  const unpaidInterests = loanData.interest_amount - loanData.paid_interests;
  const unpaidPrincipal = safeNetPrincipalAmount - loanData.paid_principal;
  const totalUnpaid = formatNumber(
    unpaidInterests + unpaidPrincipal,
    currencies[loanMetaData.principal_currency].decimal
  );

  const formattedUnpaidPrincipal = formatNumber(
    unpaidPrincipal,
    currencies[loanMetaData.principal_currency].decimal
  );
  const formattedUnpaidInterests = formatNumber(
    unpaidInterests,
    currencies[loanMetaData.principal_currency].decimal
  );
  const formattedTotalUnpaid = formatNumber(
    totalUnpaid,
    currencies[loanMetaData.principal_currency].decimal
  );

  const displayUnpaidPrincipal = `${formattedUnpaidPrincipal} ${loanMetaData.principal_currency}`;
  const displayUnpaidInterests = `${formattedUnpaidInterests} ${loanMetaData.principal_currency}`;
  const displayTotalUnpaid = `${formattedTotalUnpaid} ${loanMetaData.principal_currency}`;

  const { refetch: refetchAllWallets, isLoading: isAllWalletsLoading } = useLedgerFilteredWallets(
    WALLETS_ALL,
    {
      enabled: false,
      onSettled(data, error) {
        const currentWalletFilter = data.filter(
          (w) => w.coin.toLowerCase() === loanMetaData.principal_currency.toLowerCase()
        );
        if (currentWalletFilter.length > 0) {
          setCurrentWallet(currentWalletFilter[0]);
          const currency = currencies[currentWalletFilter[0].coin];
          setCurrencyBalanceLabel(
            `${formatNumber(
              currentWalletFilter[0].available_balance * currency?.conversion,
              currency?.decimal
            )} ${currentWalletFilter[0].coin}`
          );
        }
        if (error) {
          showAlert({ message: error.message, type: 'danger' });
        }
      },
    }
  );

  useEffect(() => {
    refetchAllWallets();
  }, []);

  const { isLoading: isRepayingLoan, mutate: repayLoan } = useMutation(LOAN_REPAY, {
    onSettled(_, error) {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else {
        hideModal();
        showAlert({
          message: translate('repay_loan_success_message'),
          type: 'success',
        });
      }
    },
  });

  const renderFooter = () => (
    <button
      className="btn btn-primary"
      disabled={isRepayingLoan || isAllWalletsLoading}
      type="button"
      onClick={() => {
        repayLoan({
          wallet: currentWallet,
          id: loanData.id,
          amount: formatNumber(totalUnpaid, exchange.MAX_PRECISION),
        });
      }}>
      {translate('continue_btn_title')}
    </button>
  );

  return (
    <ModalBodyLayout
      withBack
      title={translate('loans_details_title_label')}
      renderFooter={renderFooter}
      onPrevClick={showScreen}>
      <div>
        <div className="d-flex flex-row align-items-center justify-content-between mt-4 py-3 px-3 bg-light rounded">
          <div className="d-flex flex-row align-items-center justify-content-between w-30">
            <div className="d-flex flex-row align-items-center justify-content-between">
              {currentWallet?.coin && (
                <CurrencyIcon
                  currencyCode={currentWallet?.coin}
                  style={{ width: '1.5rem', height: '1.5rem' }}
                />
              )}
              <h2 className="ms-2 m-0 text-uppercase">{currentWallet?.coin}</h2>
            </div>
          </div>
          <div className="d-flex flex-column text-end">
            <h2 className="m-0 text-uppercase">{currencyBalanceLabel}</h2>
            <span className="text-shadow text-f6">{translate('available_balance_label')}</span>
          </div>
        </div>
        <div className="text-f6 text-shadow text-start" style={{ marginTop: '0.75rem' }}>
          <p>
            {translate('loans_payment_collateral_note_repay').replace(
              '_CURRENCY_',
              currentWallet?.coin?.toUpperCase()
            )}
          </p>
        </div>
        <div className="mt-3 pt-3 text-f6 text-shadow text-start">
          <span className="text-bold">{translate('details_button_title')}</span>
          <div className="rounded-extra bg-light mt-3">
            <div className="flex-row-center px-3 py-3 border-bottom border-disabled">
              <p className="text-f6 text-shadow">{translate('repay_loan_unpaid_principal')}</p>
              <b className="text-f6 text-dark text-uppercase">{displayUnpaidPrincipal}</b>
            </div>
            <div className="flex-row-center px-3 py-3">
              <p className="text-f6 text-shadow">
                {translate('repay_loan_unpaid_principal_interest')}
              </p>
              <b className="text-f6 text-dark text-uppercase">{displayUnpaidInterests}</b>
            </div>
          </div>
        </div>
        <div className="text-f6 text-shadow text-start" style={{ marginTop: '0.75rem' }}>
          <div className="rounded-extra bg-light mt-2">
            <div className="flex-row-center px-3 py-3 border-bottom border-disabled">
              <p className="text-f6 text-shadow">{translate('transactions_details_total')}</p>
              <b className="text-f6 text-dark text-uppercase">{displayTotalUnpaid}</b>
            </div>
            <div className="flex-row-center px-3 py-3">
              <p className="text-f6 text-shadow">{translate('crypto_amount_returned')}</p>
              <b className="text-f6 text-dark text-uppercase">{displaySafeCollateralAmount}</b>
            </div>
          </div>
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default RepayLoan;

RepayLoan.propTypes = {
  loanDataObj: PropTypes.object,
  showScreen: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
};
RepayLoan.defaultProps = {
  loanDataObj: null,
};
